import * as React from 'react';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';

export default function RequestPagination(props) {
  
 console.log("current page",props.page);
 

  return (
    <Stack spacing={2} mt={1} >
      <Pagination count={props.count} page={props.page} onChange={props.handlePageChange} />
    </Stack>
  );
}
